{
  "apply": "Applica",
  "buttonLabel": "Filtri",
  "close": "Arresta",
  "deleteSelectedFilter": "Elimina il filtro selezionato",
  "header": "Filtri",
  "searchByName": "Ricerca per nome",
  "model": "Gamma",
  "type": "Tipo",
  "clearFilters": "Elimina i filtri",
  "connectivity": "Connettività",
  "certificate": "Certificato",
  "state": "Stato",
  "certificateValidity": {
    "title": "Validità del certificato",
    "expired": "Scaduto",
    "validityUnder1": "Valido < 1 mese",
    "validityUnder3": "Valido < 3 mesi",
    "validityUnder6": "Valido < 6 mesi",
    "validityAfter6": "Valido > 6 mesi",
    "label": "data di scadenza del certificato"
  },
  "validityInMonth": "La validità selezionata è in mesi",
  "range": "Gamma",
  "creationDate": {
    "label": "Data di aggiunta",
    "formatter": {
      "input": "DD/MM/YYYY",
      "tag": "DD/MM/YYYY"
    },
    "periodSeparator": "a",
    "placeholder": "Selezionare un periodo"
  },
  "selectCreationDate": "Selezionare la data",
  "date": {
    "to": "a",
    "startPlaceholder": "Data di inizio",
    "endPlaceholder": "Data di fine",
    "formatter": {
      "tag": "DD/MM/YYYY"
    },
    "periodSeparator": "a",
    "period": {
      "placeholder": "Selezionare un periodo",
      "separator": "a"
    }
  },
  "resetFilter": "Elimina il filtro",
  "validateFilter": "Convalida il filtro",
  "searchDevice": "Cerca apparati",
  "sector": "Rete",
  "searchOperations": "Cerca operazioni",
  "searchByLastNameOrFirstName": "Cerca per cognome o nome",
  "search": "Cerca",
  "status": "Stato",
  "firmware": {
    "range": "Tipo"
  },
  "connectivityState": {
    "active": "Connesso",
    "inactive": "Inattivo"
  }
}
